const Builder = require('./BuilderBase');

module.exports = class RangeNumber extends Builder {
    constructor(title, properties) {
        super('rangeType_Number', title, properties);
    }
};
